import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux';
import DataTable from 'react-data-table-component';
import {useLocation} from "react-router-dom";
import {get_budget_reappropriate} from "../../helper/Api";
import {AiOutlineEye} from 'react-icons/ai';
import {Link} from 'react-router-dom';
import CustomBreadcrumbs from '../Tools/Breadcumbs';
import { Card, CardContent, Chip } from '@mui/material';

export default function BudgetReappropriateList(filterData) {
    const {authData} = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    let {state} = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);
    

    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'View Order',
            selector: (row) => <Link to={`/add-budget-reappropriate/${row.id}?screenType=View`}><AiOutlineEye/></Link>,
            wrap: true,
            width: "100px",
            center: true
        },
        {
            name: (row) => (row.l3_approval == null || row.l2_approval == null ? 'Edit Order' : ''),
            selector: (row) => (
                (row.l3_approval == null || row.l2_approval == null) && 
                <Link to={`/add-budget-reappropriate/${row.id}?screenType=Edit`}>
                    <AiOutlineEye />
                </Link>
            ),
            wrap: true,
            width: "100px",
            center: true
        },
        {
            name: 'Order No',
            selector: (row) => row.order_no,
            wrap: true,
            width: "200px"
        },
        {
            name: 'Order Date',
            selector: (row) => row.order_date,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Order Amount',
            selector: (row) => row.order_value,
            wrap: true,
            width: "200px"
        },
        {
            name: 'Reappropriate Amount',
            selector: (row) => {
                let year = '';
                row.toSubheads.map(e => {
                    year += e.reappropriation_amount;
                })
                return <>{year}</>
            },
            wrap: true,
            width: "200px"
        },
        {
            name: 'Status L2',
            selector: (row) => row.l2_approval == null ? <Chip label="Pending" color="warning" size="small" /> : row.l2_approval == 1 ? <Chip label="Approved" color="success" size="small" /> : <Chip label="Rejected" color="error" size="small" />,
            wrap: true,
            width: "100px"
        },
        {
            name: 'Status L3',
            selector: (row) => row.l3_approval == null ? <Chip label="Pending" color="warning" size="small" /> : row.l3_approval == 1 ? <Chip label="Approved" color="success" size="small" /> : <Chip label="Rejected" color="error" size="small" />,
            wrap: true,
            width: "100px"
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const fetchChallans = async () => {
        try {
            const resp = await get_budget_reappropriate({
                from_date: filterData?.fromDate || '', 
                to_date: filterData?.toDate || '',
                search_str: filterData?.searchStr || '',
                dateColumn: filterData?.dateColumn || ''
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }
    useEffect(() => {
        fetchChallans();
    }, [filterData.fromDate, filterData.toDate, filterData.dateColumn, filterData.searchStr])
    return (
        <div>
            <div className="row" style={{padding: "8px 10px"}}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin: 0 }}>Budget Revision</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Budget Revision" />
                </div>
                <div className="col-md-6">
                </div>
            </div>
             <Card>
                <CardContent>
                    <DataTable
                        customStyles={customStyles}
                        className="dataTables_wrapper"
                        columns={columns}
                        data={data}
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        pagination
                        paginationPerPage={rowsPerPage}
                        paginationTotalRows={data.length}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </CardContent>
            </Card>
            
        </div>
    )

}